function firstAncestorOfType(node, type) {
  if (!node) return null
  if (node.nodeName === type) return node
  return firstAncestorOfType(node.parentNode, type)
}

export function toggle(element: HTMLElement): void {
  const expanded = element.getAttribute("aria-expanded") === "true"
  const controlTargetId = element.getAttribute("aria-controls")

  /* close all list siblings and children */
  firstAncestorOfType(element, "UL")
    ?.querySelectorAll(`[aria-expanded=true]:not([aria-controls])`)
    .forEach((node) => node.setAttribute("aria-expanded", "false"))

  /* if this toggle employs aria-controls, then make sure to toggle all controllers simultaneously */
  const targets = controlTargetId
    ? document.querySelectorAll(`[aria-controls="${controlTargetId}"]`)
    : [element]

  /* if we're closing then make sure to also close all toggles withing the control target, if there is one */
  if (expanded && controlTargetId) {
    document
      .getElementById(controlTargetId)
      ?.querySelectorAll(`[aria-expanded]:not([aria-controls])`)
      ?.forEach((node) => node.setAttribute("aria-expanded", "false"))
  }

  /* if the item is already expanded don't do anything */
  if (expanded && !controlTargetId) {
    return
  }

  targets.forEach((node) =>
    node.setAttribute("aria-expanded", (!expanded).toString())
  )

  /* if there's a control target then also toggle the sentinel class */
  if (expanded) {
    document.body.classList.remove(`${controlTargetId}--open`)
  } else {
    document.body.classList.add(`${controlTargetId}--open`)
  }
}
